import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom'; // Import za navigaciju
import axios from 'axios';
import './SearchContainer.css';

const SearchContainer = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]); // Rezultati pretrage
    const [loading, setLoading] = useState(false); // Stanje za loading
    const [errorMessage, setErrorMessage] = useState(''); // Poruka o grešci
    const navigate = useNavigate(); // Hook za navigaciju
    const [isSearchReady, setIsSearchReady] = useState(false); // Ovaj flag označava da li je pretraga završena

    // Debounce efekat za unos
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (searchTerm.length > 2) { // Pokrećemo pretragu samo ako je uneseno više od 2 karaktera
                fetchSuggestions(searchTerm);
            } else if (searchTerm === '') {
                setSuggestions([]); // Resetujemo rezultate kad korisnik obriše unos
            }
        }, 1000); // Čeka 1 sekundu nakon poslednjeg unosa

        // Očisti timeout ako korisnik nastavi da kuca pre nego što prođe 1 sekunda
        return () => clearTimeout(timeoutId);
    }, [searchTerm]); // Ponovo se pokreće svaki put kada se searchTerm promeni

    const fetchSuggestions = async (query) => {
        setLoading(true); // Pokrećemo loading dok čekamo rezultate
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/search`, // API endpoint za pretragu
                { params: { query } }
            );
            setSuggestions(response.data); // Postavljamo rezultate pretrage
            setIsSearchReady(true); // Pretraga je završena
            setLoading(false); // Zaustavljamo loading
        } catch (error) {
            console.error('Error fetching search results:', error);
            setLoading(false); // Zaustavljamo loading u slučaju greške
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (!searchTerm.trim()) {
                setErrorMessage('Please enter a search term.'); // Prikazujemo poruku ako je polje prazno
                setTimeout(() => {
                    setErrorMessage(''); // Sakrivamo poruku nakon 3 sekunde
                }, 3000);
                return; // Prekidamo dalji tok ako ništa nije uneto
            }

            if (isSearchReady) {
                // Preusmeravanje na stranicu sa rezultatima pretrage
                navigate('/search-results', { state: { results: suggestions } });
            } else {
                setErrorMessage('Please wait. Search is in progress.'); // Poruka dok čekamo na rezultate
                setTimeout(() => {
                    setErrorMessage(''); // Sakrivamo poruku nakon 3 sekunde
                }, 3000);
            }
        }
    };

    return (
        <div className="search-container">
            {/* Poruka o grešci iznad searchbox-a */}
            {errorMessage && (
                <div className="error-message">
                    {errorMessage}
                </div>
            )}

            <div className="search-box">
                <img src="/images/search-icon.svg" className="icon" alt="Search" />
                <input
                    type="text"
                    placeholder="Search for accommodation"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)} // Update search term as user types
                    onKeyPress={handleKeyPress} // Dodajemo detekciju Enter tastera
                    className="search-input"
                />

                {/* Ako je loading true, prikazujemo spinner */}
                {loading && <div className="loading-spinner"></div>}

                {/* Prikazivanje predloga ako nisu u fazi učitavanja */}
                {suggestions.length > 0 && !loading && (
                    <ul className="suggestions">
                        {suggestions.map((item) => (
                            <li key={item.id}>
                                {/* Link za preusmeravanje na detalje */}
                                <Link to={`/accommodations/${item.slug}`}>
                                    {item.name} - {item.location}, {item.country}
                                </Link>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default SearchContainer;
